export enum TipoAgrupamentoMarketShare {
    MODELO_NOME = "modelo_nome",
    MARCA_NOME = "marca_nome",
    GRUPO_MODELO_NOME = "grupo_modelo_nome"
}
